"use client";

import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            // Show button when page is scrolled down 400px
            if (window.scrollY > 400) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility, { passive: true });
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    if (!isVisible) return null;

    return (
        <button
            onClick={scrollToTop}
            className="fixed bottom-20 right-4 md:bottom-8 md:right-8 z-40 p-3 bg-[#00ff9d] text-black rounded-full shadow-lg shadow-[#00ff9d]/30 hover:bg-[#00cc7d] transition-all duration-300 hover:scale-110 min-w-[48px] min-h-[48px] flex items-center justify-center"
            aria-label="Back to top"
            title="Back to top"
        >
            <ArrowUp className="w-5 h-5" />
        </button>
    );
}
